import { useDispatch, useSelector } from "react-redux";
import { downloadTradesReportExcel } from "../thunks/downloadTradesReportExcel";
import React from "react";
import { StoreType } from "../../../../../core/store/reducers";
import { FetchStateType } from "../../../../models";

export const useTradesExcelReportDownloader = () => {
	const fetchState = useSelector<StoreType, FetchStateType>(
		s => s.data.reports.exchbusiness.clientOverview.fetchState
	);
	const dispatch = useDispatch();
	const download = React.useCallback(() => dispatch(downloadTradesReportExcel()), [dispatch]);

	return [download, fetchState] as [typeof download, typeof fetchState];
};
